<div *ngIf="loaded; else profileLoading">
  <div class="field xl:col-12 md-8" *ngIf="isLegalEntity">
    <small class="p-text-secondary">
      Ця компанія — юридична особа компанії
      <strong>{{ customerMainCompanyName || ('CLIID ' + customerMainCompanyId) }}</strong>.
      Рівень клієнта встановлюється і діє на всю групу лише на головній компанії.
    </small>
    <div class="mt-2">
      <button pButton pRipple type="button" label="Відкрити головну компанію" icon="pi pi-external-link"
              class="p-button-text w-auto" (click)="onOpenMainCompany()"></button>
    </div>
  </div>
  <div class="fluid formgrid grid">
    <div class="field xl:col-4 sm:col-12 md-2">
      <label for="tier">Рівень</label>
      <p-dropdown id="tier" [options]="tierOptions" [(ngModel)]="profile.tier" optionLabel="label" optionValue="value"
                  [disabled]="!mainCompanyLoaded || isLegalEntity"></p-dropdown>
    </div>
    <div class="field xl:col-4 sm:col-12 md-2" style="overflow: visible !important">
      <label for="accountManager">Відповідальний менеджер</label>
      <app-personselector id="accountManager" [parentCompany]="mainCompanyId" [selectedID]="profile.account_manager" [showClear]="true" [showLabel]="false"
                          [disabled]="!mainCompanyLoaded || isLegalEntity"
                          placeholder="Обрати менеджера..." (selectedPersonID)="profile.account_manager = $event"></app-personselector>
    </div>
    <div class="field xl:col-4 sm:col-12 md-2" style="overflow: visible !important">
      <label for="overrideCompany">Компанія (override)</label>
      <app-companyselector id="overrideCompany" [parentCompany]="mainCompanyId" [selectedID]="profile.override_company_id" [showLabel]="false"
                           [showEditButton]="false" [showAddButton]="false" [showSearchButton]="false"
                           [disabled]="!mainCompanyLoaded || isLegalEntity"
                           placeholder="—" (selectedCompanyID)="profile.override_company_id = $event"></app-companyselector>
    </div>
    <div class="field xl:col-12 md-8">
      <label for="notes">Примітки</label>
      <textarea pInputTextarea id="notes" rows="3" [(ngModel)]="profile.notes" [disabled]="!mainCompanyLoaded || isLegalEntity"></textarea>
    </div>
    <div class="field xl:col-12 md-4 flex flex-column justify-content-end" *ngIf="profile.tier_set_by">
      <small>Востаннє змінено: {{tierSetByName || profile.tier_set_by}} ({{profile.tier_set_at | date:'short'}})</small>
    </div>
  </div>
  <div class="grid formgrid justify-content-end">
    <button pButton pRipple label="Зберегти" icon="pi pi-check" class="w-auto mr-2" [disabled]="saving || !mainCompanyLoaded || isLegalEntity" (click)="save()"></button>
  </div>
</div>
<ng-template #profileLoading>
  <p>Інформація завантажується...</p>
</ng-template>
